import { render, staticRenderFns } from "./healthInfo.vue?vue&type=template&id=ad133ebe&scoped=true"
import script from "./healthInfo.vue?vue&type=script&lang=js"
export * from "./healthInfo.vue?vue&type=script&lang=js"
import style0 from "./healthInfo.vue?vue&type=style&index=0&id=ad133ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad133ebe",
  null
  
)

export default component.exports